import { InternalAccountPage } from './InternalAccountPage';
export default InternalAccountPage;